import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoadchargeComponent } from './loadcharge.component';

const routes: Routes = [
  { path: '', component: LoadchargeComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoadchargeRoutingModule { }
